/* istanbul ignore file */
import {
  CREATE_EXPENSE,
  EXPENSE_TYPES,
  FIND_EMPLOYEE_EXPENSES_BY_LEAVE_IDS,
  useExpenseUrl,
} from 'domain/shared/expense';
import { CreateButton } from 'framework/ui/ui-builder';
import { useShowContext } from 'framework/show';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { LeaveDto } from '../types';
import { LEAVE_TYPES } from '../constants';

export const isLeaveCompensationButtonVisible = (data: { hasCompensation: boolean; status: string; type: string }) => {
  return (
    !data.hasCompensation && ['REGISTERED', 'APPROVED'].includes(data.status) && !['UNPAID_LEAVE'].includes(data.type)
  );
};

const AddLeaveCompensationButton = (props: { isVisible: boolean | ((data: any) => boolean) }) => {
  const { getCreateUrl } = useExpenseUrl();
  const { data } = useShowContext<LeaveDto>();
  const {
    id,
    employeeAlias,
    type: leaveType,
    period: { startDate, actualEndDate: endDate },
  } = data.getData() || {};
  const { formatDate } = useDateService();

  let type = leaveType;
  if (leaveType === 'COMPENSATION') {
    type = 'PAID_LEAVE';
  }

  const expenseData = {
    employeeAlias,
    leaveId: String(id),
    subtype: type,
    type: EXPENSE_TYPES.LEAVE_COMPENSATION,
    title: `${LEAVE_TYPES[leaveType as keyof typeof LEAVE_TYPES]}, ${formatDate(
      startDate,
      DATE_FORMAT.FULL_DATE,
    )?.trim()} - ${formatDate(endDate, DATE_FORMAT.FULL_DATE)?.trim()}`,
    registrationDate: startDate,
  };

  return (
    <CreateButton
      url={`${getCreateUrl()}?${new URLSearchParams(expenseData).toString()}`}
      label="Add Compensation"
      key="create-expense"
      permissionToCheck={[CREATE_EXPENSE, FIND_EMPLOYEE_EXPENSES_BY_LEAVE_IDS]}
      variant="outlined"
      hasIcon={false}
      openInNewTab
      {...props}
    />
  );
};

export default AddLeaveCompensationButton;
